import * as React from 'react';

interface QuickSummaryProps {
  character_count: number;
  contribution_to_overall: number;
  cost_estimate: string;
  key_topics: string[];
  summary: string;
  summary_type: string;
  tone_description: string;
  word_count: number;
}

const QuickSummary: React.FC<{ data: QuickSummaryProps }> = ({ data }) => {
  if (!data.summary || !data.key_topics) return null;

  const { key_topics, summary } = data;

  return (
    <div>
      <div className="Stack">
        <div className="Stack">
          <div>Key Topics:</div>
          <ul>
            {key_topics.map((topic, index) => (
              <li key={`${index}-${topic}`}>{topic}</li>
            ))}
          </ul>
        </div>
        <div>Summary: {summary}</div>
      </div>
    </div>
  );
};

export default QuickSummary;
